import React from 'react';
import { ElevateCheckbox } from './ElevateCheckbox';
import { css, cx } from 'linaria';
import { CustomStoreFacet } from './CustomStoreFacet';

const checkboxFacetListStyle = css`
  background: #f3f3f3;
`;

export const CheckboxFacet = ({ clickCallback, page, ...props }) => {
  if (props.id === 'onlyInStock') {
    return <CustomStoreFacet defaultSelected={!!props.selected} />;
  }

  return (
    <ul className={cx('checkbox-facet-list', checkboxFacetListStyle)}>
      <li>
        <ElevateCheckbox
          label={`${props.label}`}
          count={props.count}
          checked={props.selected}
          onChange={() =>
            clickCallback({ id: 'true', selected: props.selected }, props)
          }
        />
      </li>
    </ul>
  );
};
